import { careerDictionary } from '@common/const/catalog/career';
import { BlockDictionary } from '@common/model/blocks';
import { useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { useCurrentCity } from '@cp/entities/location';
import { useCallback, useMemo } from 'react';

export const useBlockDictionary = () => {
  const { pageProps } = useClientWebRouteParams();
  const { currentCity } = useCurrentCity({ allowEmptyValue: true });
  const dict = useMemo<Record<BlockDictionary, string | undefined>>(() => {
    const { translation } =
      pageProps && typeof pageProps === 'object' && 'careerId' in pageProps ? careerDictionary[pageProps.careerId] : { translation: null };
    return {
      [BlockDictionary.cityName]: currentCity?.translation.name,
      [BlockDictionary.cityNamePrepositional]: currentCity?.translation.namePrepositional,
      [BlockDictionary.catalogNameSingle]: translation?.nameSingle,
      [BlockDictionary.catalogNameSinglePrepositional]: translation?.nameSinglePrepositional,
      [BlockDictionary.catalogNameSingleInstrumental]: translation?.nameSingleInstrumental,
      [BlockDictionary.catalogNameSingleGenitive]: translation?.nameSingleGenitive,
      [BlockDictionary.catalogNameSingleDative]: translation?.nameSingleDative,
      [BlockDictionary.catalogNameSingleAccusative]: translation?.nameSingleAccusative,
      [BlockDictionary.catalogNameDeclination1]: translation?.nameDeclination1,
      [BlockDictionary.catalogNameDeclination2]: translation?.nameDeclination2,
      [BlockDictionary.catalogNameDeclination3]: translation?.nameDeclination3,
      [BlockDictionary.catalogNamePlural]: translation?.namePlural,
      [BlockDictionary.catalogNamePluralGenitive]: translation?.namePluralGenitive,
      [BlockDictionary.catalogNamePluralPrepositional]: translation?.namePluralPrepositional,
    };
  }, [currentCity, pageProps]);

  return useCallback(
    (props: Record<string, unknown>, mixture?: Record<string, unknown>): Record<string, unknown> => {
      let propsStr = JSON.stringify(props);
      const taponyms = { ...mixture, ...dict };
      for (const key in taponyms) {
        if (taponyms[key]) {
          const regex = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
          propsStr = propsStr.replace(regex, dict[key].replace(/"/g, '\\"'));
        }
      }
      return JSON.parse(propsStr.replace(/\{\{.*?\}\}/g, ''));
    },
    [dict],
  );
};
